import { useSelector } from '@legendapp/state/react';
import { useTranslation } from 'react-i18next';
import { sync$ } from '../store/sync$';
import { getSyncIndicatorState } from '../utils/syncStatus';

/**
 * Compact sync status indicator. The UI is color-only; accessible text is
 * exposed through aria-label/title so every state remains understandable.
 */
export const SyncIndicator = () => {
  const { t } = useTranslation('common');
  const isOnline = useSelector(() => sync$.isOnline.get());
  const isSyncing = useSelector(() => sync$.isSyncing.get());
  const pendingChanges = useSelector(() => sync$.pendingChanges.get());
  const error = useSelector(() => sync$.error.get());
  const { status, text } = getSyncIndicatorState(
    { isOnline, isSyncing, pendingChanges, error },
    t
  );

  return (
    <span
      className={`sync-indicator sync-indicator--${status}`}
      role="status"
      aria-label={text}
      title={text}
      data-testid="sync-indicator"
      data-sync-status={status}
    >
      <span className="sync-indicator-dot" aria-hidden="true" />
    </span>
  );
};

export default SyncIndicator;
